import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";

const ExportAttendanceHistoryExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Attendance History");
  const t = i18n.t.bind(i18n);

 worksheet.columns = [
    { header: t("attendanceHistory.tableHeaders.id"), key: "id", width: 12 },
    { header: t("attendanceHistory.tableHeaders.fullName"), key: "fullName", width: 25 },
    { header: t("attendanceHistory.tableHeaders.date"), key: "date", width: 20 },
    { header: t("clockIn"), key: "checkIn", width: 15 },
    { header: t("clockOut"), key: "checkOut", width: 15 },
    { header: t("breakStart"), key: "breakStart", width: 15 },
    { header: t("breakEnd"), key: "breakEnd", width: 15 },
    { header: t("attendanceHistory.tableHeaders.location"), key: "location", width: 30 },
    { header: t("attendanceHistory.tableHeaders.details"), key: "details", width: 25 },
    { header: t("attendanceHistory.tableHeaders.status"), key: "status", width: 15 },
  ];

  worksheet.addRows(data);

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Attendance_History_${new Date().toISOString().slice(0,10)}.xlsx`);
};

export default ExportAttendanceHistoryExcel;
